import { styled } from "styled-components";
import { focusVisible, measures } from "../lib/ui";

// real buttons (keyboard + screen-reader accessible) wrapping pill/icon SVGs.
// type="button" so they never trigger implicit form submits — callers drive
// behaviour through onClick.
const toggleButtonBase = `
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    /* comfortable hit target around the visual pill */
    min-height: 48px;
    min-width: 48px;
    ${focusVisible}
    svg {
        height: ${measures.topBar.landscape.icon};
    }
`;

export const StyledToggle = styled.button.attrs({ type: "button" })`
    ${toggleButtonBase}
    svg:hover path {
      fill: ${props => props.theme.buttonHover}; /* Change the fill color on hover */
    }

    svg:hover rect {
      fill: ${props => props.theme.backgroundColor};
      stroke: ${props => props.theme.buttonHover};
      stroke-width: 2px;
 /* Change the fill color on hover */
    }
`;

export const StyledToggleBlack = styled.button.attrs({ type: "button" })`
    ${toggleButtonBase}
    svg:hover path {
      fill: ${props => props.theme.navigationText}; /* Change the fill color on hover */
    }

    svg:hover text {
      fill: ${props => props.theme.navigationText}; /* Change the fill color on hover */
    }

    svg:hover rect {
      fill: ${props => props.theme.backgroundColor};
      stroke: ${props => props.theme.navigationText};
 /* Change the fill color on hover */
    }
`;

export const StyledToggleRed = styled.button.attrs({ type: "button" })`
    ${toggleButtonBase}
    svg:hover text {
      fill: ${props => props.theme.white}; /* Change the fill color on hover */
    }

    svg:hover rect {
      fill: ${props => props.theme.red};
 /* Change the fill color on hover */
    }
`;
